import { RootState } from '../store';
import { OptimizelyOverrides } from 'shared/optimizely/optimizelyOverrides';
import { HYDRATE } from 'next-redux-wrapper';

type ForcedFeatures = OptimizelyOverrides['features'];

const SET_FORCED_FEATURES = 'optimizely/SET_FORCED_FEATURES';

type SetForcedFeaturesAction = {
    type: typeof SET_FORCED_FEATURES;
    features: ForcedFeatures;
};

type HydrateOptimizelyAction = {
    type: typeof HYDRATE;
    payload: RootState;
};

type OptimizelyActionType = SetForcedFeaturesAction | HydrateOptimizelyAction;

export type OptimizelyState = {
    forcedFeatures: ForcedFeatures;
};

const initialState: OptimizelyState = {
    forcedFeatures: {}
};

export const optimizely = (
    state = initialState,
    action: OptimizelyActionType
): OptimizelyState => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.optimizely
            };
        }
        case SET_FORCED_FEATURES:
            return {
                ...state,
                forcedFeatures: action.features
            };
        default:
            return state;
    }
};

export const setForcedFeatures = (
    features: ForcedFeatures
): SetForcedFeaturesAction => ({
    type: SET_FORCED_FEATURES,
    features
});

export const selectForcedFeatures = (state: RootState): ForcedFeatures =>
    state.optimizely.forcedFeatures;

export default optimizely;
